<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
            <div class="select col" >
                <select v-model="location_id" :disabled="this.loading==true">
                  <option value="">Makeup Location</option>
                  <option :value="row.id" v-for="row in makeuplocations" :key="row.id">{{ row.name }}</option>
                  
                </select>
              </div>  
            <div class="select col" >
                <select v-model="area"  :disabled="this.loading==true">
                  <option value="">All Operations</option>
                  <option value="received">Received</option>
                  <option value="on_factory_floor">On Factory Floor</option>
                  <option value="off_factory_floor">Off Factory Floor</option>
                  <option value="embroidery">Embroidery</option>
                  <option value="silicon_stripes">Silicon Stripes</option>
                  <option value="gps_pockets">GPS Pockets</option>
                  <option value="embossing">Embossing</option>
                  <option value="dtf">DTF</option>
                </select>
              </div>

              <div class="select col">
                <select v-model="user_id"  :disabled="this.loading==true">
                  <option value="">Select User</option>
                  <option  v-for="row in user_list" :key="row.user_id" :value="row.user_id">{{ row.firstname}} {{ row.surname }}</option>
                  
                </select>
              </div>

              <div class="select col">
                <select class="input" v-model="range_id"  :disabled="this.loading==true">
                <option value="">All Ranges</option>
                <option value="1">Jerseys</option>
                <option value="2">Leisurewear</option>
                <option value="3">Shorts</option>
                <option value="4">Accessories</option>
              </select>

              </div>
            

             <div class=" col">
                <input type="date" class="input" v-model="start_date"  :disabled="this.loading==true"/>
                
              </div>
              <div class=" col" >
                <input type="date" class="input" v-model="end_date"  :disabled="this.loading==true"/>
                
              </div>

              <div class="col">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total {{ total_label }}</td>
                        <td>{{ total_qty }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        
      </div>
      <div class="notification is-info" v-if="loading == true">Loading data ...</div>

    <table class="table is-hoverable is-fullwidth is-size-7" id="entriestable" v-if="loading == false && filteredEntries.length > 0">
    	<thead>
    		<tr>
          <th>Date </th>
          <th>Operation</th>
          <th>User </th>
        <th>Qty</th>
        <th>Size</th>
        <th>Order</th>
        <th>Range</th>
        <th>Garment</th>
        <th>Design Name</th>
       
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="row in filteredEntries" v-bind:key="row.id" >
          <td >{{ row.date }}</td>
          <td >{{ row.area }}</td>
          <td >{{ row.firstname }} {{ row.surname }}</td>
          <td>{{row.qty}}</td>
          <td>{{row.size_name}}</td>
          <td>{{row.ponumber}}</td>
          <td>{{row.range}}</td>
          <td>{{row.garmentname}}</td>
          <td>{{row.designname}}</td>
			</tr>
    	</tbody>
    </table>
    


    <button @click="exportXLS()" class="button is-info" v-if="loading==false">Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  name:'PrintingCuttingSummary',
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
     entries: [],
     area: '',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      loading: true,
     accessToken: '',
     location_id: '',
     makeuplocations: [],
     range_id:'',
     user_id: '',
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
          this.getMakeupLocations();
            this.getData()
        });
      
    },
  methods: {
    
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('entriestable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Bundle Summary Report.xlsx')

	 },
   
    async getData() {
      this.loading=true;
      OrderService.getBundleReportData(this.accessToken, this.area, this.start_date, this.end_date, this.location_id, this.range_id)
          .then(
            (entries => {
              
              this.$set(this, "entries", entries);
              this.loading=false;
            }).bind(this)
          );
      
    },
   
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },

        
   
  },
  computed : {
      user_list: function() {
          let user_list = []
          let user_id_list = []
          
          this.entries.forEach(element => {
             
             if(!user_id_list.includes(element.user_id))
             {
              var this_user = {user_id: element.user_id, firstname: element.firstname, surname: element.surname}
              user_list.push(this_user)

              user_id_list.push(element.user_id)
             }
            
          })

          user_list.sort()

          return user_list
        },
    
      total_qty: function() {
        return this.filteredEntries.reduce((total, item) => total + item.qty, 0);
      },
      total_label: function() {
          if(this.area == "savings")
          {
            return "Orders"
          }
          else{
            return "Garments"
          }
        },
        filteredEntries: function () {
          let filteredEntries = []

          if(this.user_id != "")
          {
            filteredEntries = this.entries.filter(row => row.user_id == this.user_id)

           
          }
          else
          {
            filteredEntries = this.entries
          }
          

            return filteredEntries
        
      },

  },

 
  mounted() {
    if (localStorage.makeup_summary_report_location_id) {
      this.location_id = localStorage.makeup_summary_report_location_id;
    }
    else{
      this.location_id = ''
    }

    if (localStorage.makeup_summary_report_area) {
      this.area = localStorage.makeup_summary_report_area;
    }
    else{
      this.area = ''
    }

    if (localStorage.makeup_summary_range_id) {
      this.range_id = localStorage.makeup_summary_range_id;
    }
    else{
      this.range_id = ''
    }
  },
  watch: {
    
    start_date: function () {
      this.entries = []
      this.getData()
    },
    end_date: function () {
      this.entries = []
      this.getData()
    },
    location_id: function () {
      localStorage.makeup_summary_report_location_id = this.location_id
      if(this.accessToken != "")
      {
        this.entries = []
        this.getData()
      }
    },
    area: function () {
      localStorage.makeup_summary_report_area = this.area
      if(this.accessToken != "")
      {
        this.entries = []
        this.getData()
      }
    },
    range_id: function () {
      localStorage.makeup_summary_range_id = this.range_id
      if(this.accessToken != "")
      {
        this.entries = []
        this.getData()
      }
    },
  }
}



</script>


